import React from "react";
import { DragDropContext, Draggable } from "react-beautiful-dnd";
import classes from "./DraggableSample.module.css";
import ScrollContainer from "react-indiana-drag-scroll";
import { mergeClass } from "../../utils/helper";
import { DragDropIcon } from "../../constant/imagePath";
import { StrictModeDroppable } from "./StrictModeDroppable";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);
  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};

const DraggableSample = ({
  heading1 = "Columns Shown",
  heading2 = "Columns Hidden",
  list1,
  list2,
  setList1,
  setList2,
  selectedItem,
  setSelectedItem,
}) => {
  const onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;

    if (source.droppableId === destination.droppableId) {
      const reorderedList = reorder(
        source.droppableId === "list1" ? list1 : list2,
        source.index,
        destination.index
      );
      if (source.droppableId === "list1") {
        setList1(reorderedList);
      } else {
        setList2(reorderedList);
      }
    } else {
      const movedResult = move(
        source.droppableId === "list1" ? list1 : list2,
        destination.droppableId === "list1" ? list1 : list2,
        source,
        destination
      );
      setList1(movedResult.list1 || list1);
      setList2(movedResult.list2 || list2);
    }
  };
  const renderList = (list, listId, title) => (
    <StrictModeDroppable droppableId={listId}>
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.droppableProps}
          className={classes.lotsCountDiv}
        >
          <h6 className={classes.title}>{title}</h6>
          <ScrollContainer className={classes.scrollDiv}>
            {list?.map((item, index) => (
              <Draggable
                key={item?.id}
                draggableId={String(item?.id)}
                index={index}
              >
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className={classes.dragList}
                    onClick={() => setSelectedItem(item)}
                  >
                    <div
                      className={mergeClass(
                        classes.dragListDetails,
                        selectedItem?.id === item?.id &&
                          classes.dragListDetailsSelected
                      )}
                    >
                      <div className={classes.dragListSpans}>
                        <p className={classes.dragListLabel}>{item?.label}</p>
                      </div>
                    </div>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </ScrollContainer>
        </div>
      )}
    </StrictModeDroppable>
  );

  return (
    <div className="App">
      <DragDropContext onDragEnd={onDragEnd}>
        <div className={classes.auctionDragDivMain}>
          {renderList(list1, "list1", `${heading1}`)}
          <div className="w-24">
            <img src={DragDropIcon} alt="" />
          </div>
          {renderList(list2, "list2", `${heading2}`)}
        </div>
      </DragDropContext>
    </div>
  );
};

export default DraggableSample;
